var _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby14Weeks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 166,
    viewBox: "0 0 153 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8942 80.1127C33.4242 81.1156 29.9812 80.339 29.9812 80.339C29.9812 80.339 28.72 83.7114 27.6214 83.5751C26.5227 83.4377 26.28 79.8777 26.28 79.8777C26.28 79.8777 22.6 79.7655 22.3901 78.6785C22.1812 77.5914 25.5749 76.2142 25.5749 76.2142C25.5749 76.2142 24.4608 72.7248 25.4298 72.19C26.3989 71.6551 28.8409 74.4115 28.8409 74.4115C28.8409 74.4115 31.7317 72.3195 32.5402 73.0758C33.3488 73.8321 31.5644 76.9598 31.5644 76.9598C31.5644 76.9598 34.3642 79.1108 33.8942 80.1127Z",
    fill: "#FFF1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.65012 69.3662C9.25649 70.2066 6.37055 69.5567 6.37055 69.5567C6.37055 69.5567 5.31347 72.3836 4.39276 72.2685C3.47205 72.1535 3.26798 69.1698 3.26798 69.1698C3.26798 69.1698 0.182813 69.076 0.00776078 68.165C-0.167291 67.2539 2.67706 66.0992 2.67706 66.0992C2.67706 66.0992 1.7428 63.1746 2.5552 62.7268C3.36759 62.278 5.41406 64.5885 5.41406 64.5885C5.41406 64.5885 7.83673 62.8351 8.5147 63.4695C9.19266 64.104 7.69747 66.7249 7.69747 66.7249C7.69747 66.7249 10.0437 68.5257 9.65012 69.3662Z",
    fill: "#FFF1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.0778 49.245C28.4047 50.6812 23.4723 49.57 23.4723 49.57C23.4723 49.57 21.6647 54.4018 20.0911 54.2055C18.5176 54.0091 18.1685 48.9085 18.1685 48.9085C18.1685 48.9085 12.8956 48.7479 12.5958 47.1908C12.296 45.6337 17.1588 43.6598 17.1588 43.6598C17.1588 43.6598 15.563 38.6607 16.9509 37.8947C18.3397 37.1278 21.8378 41.0775 21.8378 41.0775C21.8378 41.0775 25.98 38.0804 27.1377 39.1645C28.2954 40.2487 25.7402 44.7294 25.7402 44.7294C25.7402 44.7294 29.7509 47.8088 29.0778 49.245Z",
    fill: "#FFF1C8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M79.1584 153.208C119.391 153.208 152.005 147.684 152.005 140.87C152.005 134.056 119.391 128.532 79.1584 128.532C38.9263 128.532 6.31177 134.056 6.31177 140.87C6.31177 147.684 38.9263 153.208 79.1584 153.208Z",
    fill: "#FF6B6B",
    fillOpacity: 0.76
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M127.856 98.0031C127.709 98.0195 127.563 98.0408 127.416 98.0698C127.614 98.0311 127.948 98.1578 128.146 98.1984C128.398 98.2507 128.65 98.3116 128.898 98.3793C129.35 98.5031 129.798 98.5427 130.159 98.8764C130.469 99.1617 130.623 99.6617 130.393 100.015C130.168 100.362 129.697 100.431 129.285 100.457C128.53 100.503 127.773 100.516 127.017 100.492C127.786 100.763 130.493 101.691 129.32 102.813C128.609 103.493 126.319 103.272 125.414 103.247C125.76 103.257 126.17 103.639 126.424 103.839C126.761 104.103 127.136 104.385 127.229 104.828C127.294 105.139 127.211 105.49 126.972 105.699C126.798 105.848 126.563 105.911 126.334 105.916C125.614 105.93 124.947 105.629 124.264 105.441C122.588 104.981 120.915 104.507 119.248 104.018C117.066 103.378 115.944 102.738 113.659 103.476C104.369 106.475 89.7571 106.512 83.3817 97.709C81.0239 94.4537 80.2772 90.9807 78.8575 87.3385C77.6021 84.1198 77.6205 80.7 79.4968 77.6158C81.1187 74.9504 84.2764 73.1225 87.3596 73.6032C89.8026 73.9842 91.8423 75.6777 93.4429 77.5626C95.4158 79.8857 98.4217 84.0995 98.1993 87.3133C103.907 88.2756 108.793 90.3559 114.162 92.4942C115.372 92.9759 116.427 93.3705 117.62 92.8173C119.03 92.1645 120.443 91.5213 121.872 90.9091C122.183 90.7757 122.503 90.6412 122.842 90.6238C123.18 90.6064 123.546 90.7292 123.731 91.0136C123.949 91.3501 123.852 91.8115 123.63 92.1461C123.409 92.4807 123.083 92.7302 122.804 93.0194C122.641 93.1887 122.487 93.3869 122.455 93.62C122.404 94.0049 122.713 94.3647 123.077 94.502C123.976 94.8434 125.071 94.8502 126.012 95.0727C127.144 95.3396 128.259 95.679 129.347 96.0891C129.704 96.2235 130.123 96.4624 130.291 96.828C130.378 97.0176 130.379 97.2506 130.271 97.4295C130.129 97.6675 129.838 97.7652 129.567 97.8251C129.256 97.8938 128.938 97.9363 128.62 97.9518C128.362 97.9615 128.109 97.975 127.856 98.0031Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M88.4067 74.0423C98.1004 77.4563 101.482 86.1121 101.482 86.1121C101.482 86.1121 97.0297 93.5252 80.8931 94.0707C80.8931 94.0707 72.802 73.7028 88.4067 74.0423Z",
    fill: "#4BB9BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.5,
    d: "M88.4067 74.0423C98.1004 77.4563 101.482 86.1121 101.482 86.1121C101.482 86.1121 97.0297 93.5252 80.8931 94.0707C80.8931 94.0707 72.802 73.7028 88.4067 74.0423Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M80.2976 94.1516C88.0502 94.6052 95.9391 91.4861 101.286 85.8555",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.5,
    d: "M125.287 96.334C125.243 98.7586 124.557 101.17 123.316 103.253",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M90.3099 112.628C94.367 111.231 97.9387 108.701 101.898 107.049C105.858 105.397 110.647 104.725 114.276 107.014C118.293 109.548 119.575 114.808 119.735 119.555C120.025 128.132 117.813 136.603 115.008 144.713C111.607 145.586 108.838 147.752 105.331 147.923C103.892 142.257 100.333 136.963 99.7153 131.149C96.1272 132.803 91.2945 129.353 89.0613 126.093C86.8301 122.833 86.5748 113.916 90.3099 112.628Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M119.316 132.958C119.286 134.505 118.892 136.528 119.219 138.034C119.571 139.657 120.393 139.479 121.948 140.203C124.575 141.425 126.928 143.237 128.764 145.48C130.069 147.072 131.158 149.13 130.639 151.123C130.285 152.48 129.216 153.569 127.973 154.219C126.73 154.868 125.322 155.129 123.929 155.281C115.049 156.248 104.031 153.581 101.154 144.145C100.295 141.324 100.087 138.449 99.9426 135.623C105.609 133.93 113.251 133.368 119.316 132.958Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M100.073 135.721C106.45 134.418 112.933 133.628 119.437 133.36",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.5,
    d: "M110.646 108.505C110.659 109.888 111.701 111.095 112.939 111.714C114.176 112.333 115.588 112.478 116.965 112.613",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M49.4873 71.4598C45.9998 71.1339 44.8596 84.9127 43.5017 87.4756C39.2308 95.5386 33.3071 101.77 31.0082 110.935C26.7644 127.854 36.9252 142.123 54.0213 144.255C62.4586 145.307 71.0806 144.859 79.3632 142.936C84.5925 141.722 89.7686 139.882 94.0859 136.69C98.4032 133.499 101.805 128.824 102.625 123.518C103.502 117.846 100.908 114.905 98.2513 110.462C96.4747 107.49 97.5463 105.443 98.0057 102.142C99.3123 92.7571 97.2329 83.0296 91.4794 75.4057C91.4794 75.4057 49.82 71.4907 49.4873 71.4598Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.5,
    d: "M45.3296 125.093C33.6408 106.585 49.5898 89.8605 51.5502 71.6532C50.2833 71.5342 49.5308 71.4637 49.4873 71.4598C45.9998 71.1339 44.8596 84.9127 43.5017 87.4756C39.2308 95.5386 33.3071 101.77 31.0082 110.935C26.7644 127.854 36.9252 142.123 54.0203 144.255C59.1287 144.893 64.3039 144.97 69.4316 144.512C66.7217 143.66 63.7004 142.66 61.2874 141.051C54.9043 136.796 49.585 131.476 45.3296 125.093Z",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M100.968 42.4809C100.839 46.1125 103.969 49.2422 104.688 52.8167C106.748 63.052 100.198 73.8568 91.9203 79.4604C85.3786 83.8879 77.1637 84.3909 69.5117 83.9199C65.1006 83.6491 60.6527 82.6703 56.8606 80.4005C51.1526 76.9836 48.3807 71.2726 44.6186 66.1081C39.9125 59.6476 36.0565 51.9453 35.717 43.8398C35.5217 39.1927 36.3563 34.5301 38.1726 30.2477C43.1098 18.6072 54.5491 10.8101 66.9778 9.41746C71.0369 8.96291 75.1646 9.07219 79.1956 9.72985C85.8186 10.8101 91.8284 14.638 95.8053 20.0153C100.561 26.4449 101.613 34.4054 100.984 42.2073C100.977 42.2991 100.972 42.39 100.968 42.4809Z",
    fill: "#876855"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M37.1619 58.8945C35.1193 60.1459 34.6957 63.0851 35.5758 65.3133C36.4559 67.5416 38.3021 69.2215 40.0884 70.8173C40.7741 71.4295 41.4801 72.0552 42.3409 72.3783C43.5276 72.8241 44.8786 72.6346 46.044 72.1346C47.2094 71.6346 48.2249 70.8483 49.2269 70.0707C49.4329 69.9111 49.6476 69.7399 49.7434 69.4972C50.341 67.9855 47.9416 62.7205 46.7665 61.4342C44.7752 59.2552 39.9085 57.2116 37.1619 58.8945Z",
    fill: "#876855"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.3,
    d: "M97.8374 50.055C96.4302 49.8954 94.9456 50.2929 93.8218 51.1692C91.3498 53.0947 90.7221 56.6896 92.7647 59.0659C93.5394 59.9682 94.5375 60.7535 95.7116 60.945C96.2764 61.0369 96.8547 60.9866 97.4205 60.9034C98.1555 60.7951 98.8896 60.6287 99.5647 60.3183C103.172 58.6577 103.159 52.7089 99.8142 50.7108C99.2078 50.349 98.5318 50.1334 97.8374 50.055Z",
    fill: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.3,
    d: "M61.1796 55.9749C59.6254 55.7979 57.9852 56.2379 56.7443 57.2051C54.0141 59.3318 53.3207 63.3019 55.577 65.9267C56.4329 66.9229 57.5345 67.7913 58.8314 68.0022C59.4552 68.1037 60.0935 68.0486 60.7183 67.9558C61.5307 67.8358 62.3402 67.6521 63.0858 67.3087C67.0695 65.475 67.055 58.9043 63.3605 56.6983C62.6941 56.2998 61.9475 56.0619 61.1796 55.9749Z",
    fill: "#1D1D1B"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M39.2268 60.7758C37.6001 61.0543 36.5479 62.9586 37.0759 64.4925C37.1475 64.7014 37.4309 64.6279 37.5034 64.4683C38.1959 62.9605 38.0614 61.5485 40.2162 61.6356C39.605 62.8706 39.6127 65.1047 40.6185 66.0041C40.8342 66.1966 41.1669 66.0651 41.1311 65.7565C41.0499 65.0679 40.7008 64.4519 40.6476 63.7391C40.5944 63.0234 40.7849 62.3967 40.9193 61.7178C42.046 61.9286 43.077 62.5108 43.9832 63.1936C44.1089 63.2884 44.312 63.1259 44.224 62.9857C43.2811 61.4905 40.988 60.474 39.2268 60.7758Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M65.0697 44.231C65.3743 44.1401 65.6848 44.0424 65.9362 43.848C66.1877 43.6546 66.3734 43.3432 66.3298 43.0289C66.2834 42.6904 65.9836 42.4292 65.6557 42.3325C65.3279 42.2358 64.9768 42.2726 64.6393 42.3267C63.0203 42.5849 61.4593 43.2145 60.1237 44.1652C59.9226 44.3084 59.7214 44.4641 59.5937 44.6749C58.7601 46.0531 60.9129 45.2571 61.3239 45.173C62.5851 44.9138 63.8356 44.5995 65.0697 44.231Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M94.988 40.018C95.4096 39.9715 95.9503 39.8013 95.9512 39.3768C95.9512 38.9628 95.4309 38.7839 95.0199 38.7375C93.2694 38.5392 91.4918 38.5905 89.7558 38.8884C88.0246 39.1853 87.3485 40.8594 89.5759 40.6137C91.3786 40.4155 93.1833 40.2162 94.988 40.018Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M84.6444 55.1784C84.1077 53.1503 81.568 53.1174 79.9703 53.7229C79.888 53.7538 79.9306 53.8602 80.006 53.8612C81.4587 53.8815 83.981 53.5091 84.157 55.6339C84.2963 57.3187 82.684 58.3487 81.42 59.0721C81.1627 59.2191 81.4181 59.6756 81.6792 59.5286C83.216 58.663 85.1889 57.2374 84.6444 55.1784Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M80.7142 67.8007C78.3524 68.0821 76.1416 68.1102 73.9539 67.0057C71.9403 65.9893 70.7391 64.4534 69.3677 62.7377C69.2817 62.6294 69.1317 62.729 69.1675 62.8518C70.5109 67.5115 76.5139 69.9574 80.9095 68.5541C81.338 68.4177 81.1465 67.7485 80.7142 67.8007Z",
    fill: "#4E4E4E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_384_1003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 44,
    width: 11,
    height: 7
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000058589471205325810310000005271091842639632542_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M96.4547 48.6856C95.5998 49.232 94.6268 49.6575 93.5959 49.9448C92.1558 50.3539 90.6016 50.497 89.1093 50.3848C88.0977 50.3084 87.1025 50.1169 86.1973 49.8007C86.5184 48.9351 86.8781 48.0453 87.3423 47.2561C87.8646 46.3461 88.5368 45.5637 89.4633 45.0917C90.7892 44.4176 92.4401 44.5627 93.7264 45.2986C94.0475 45.4776 94.3531 45.7 94.6288 45.936L94.6404 45.9447C95.4711 46.6729 96.0833 47.6449 96.4547 48.6856Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_384_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M96.4547 48.6856C95.5998 49.232 94.6268 49.6575 93.5959 49.9448C92.1558 50.3539 90.6016 50.497 89.1093 50.3848C88.0977 50.3084 87.1025 50.1169 86.1973 49.8007C86.5184 48.9351 86.8781 48.0453 87.3423 47.2561C87.8646 46.3461 88.5368 45.5637 89.4633 45.0917C90.7892 44.4176 92.4401 44.5627 93.7264 45.2986C94.0475 45.4776 94.3531 45.7 94.6288 45.936L94.6404 45.9447C95.4711 46.6729 96.0833 47.6449 96.4547 48.6856Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_384_1003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 44,
    width: 11,
    height: 7
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000058589471205325810310000005271091842639632542__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M96.4547 48.6856C95.5998 49.232 94.6268 49.6575 93.5959 49.9448C92.1558 50.3539 90.6016 50.497 89.1093 50.3848C88.0977 50.3084 87.1025 50.1169 86.1973 49.8007C86.5184 48.9351 86.8781 48.0453 87.3423 47.2561C87.8646 46.3461 88.5368 45.5637 89.4633 45.0917C90.7892 44.4176 92.4401 44.5627 93.7264 45.2986C94.0475 45.4776 94.3531 45.7 94.6288 45.936L94.6404 45.9447C95.4711 46.6729 96.0833 47.6449 96.4547 48.6856Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_384_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M88.7215 45.2449C87.2496 46.0631 86.3985 47.8678 86.7031 49.5235C87.0078 51.1792 88.4449 52.5632 90.1113 52.805C91.7777 53.0468 93.5485 52.128 94.3106 50.626C96.0824 47.1337 92.1452 43.3415 88.7215 45.2449Z",
    fill: "#4E505B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_384_1003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 47,
    width: 11,
    height: 7
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000183932316410724906580000005215203451237313929_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M70.7916 51.7324C69.9367 52.2789 68.9637 52.7044 67.9328 52.9917C66.4927 53.4008 64.9385 53.5439 63.4462 53.4317C62.4346 53.3553 61.4394 53.1638 60.5342 52.8475C60.8553 51.982 61.215 51.0922 61.6793 50.303C62.2015 49.3929 62.8737 48.6105 63.8002 48.1386C65.1261 47.4645 66.7771 47.6095 68.0633 48.3455C68.3844 48.5244 68.69 48.7469 68.9657 48.9829L68.9773 48.9916C69.809 49.7198 70.4203 50.6918 70.7916 51.7324Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_384_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M70.7916 51.7324C69.9367 52.2789 68.9637 52.7044 67.9328 52.9917C66.4927 53.4008 64.9385 53.5439 63.4462 53.4317C62.4346 53.3553 61.4394 53.1638 60.5342 52.8475C60.8553 51.982 61.215 51.0922 61.6793 50.303C62.2015 49.3929 62.8737 48.6105 63.8002 48.1386C65.1261 47.4645 66.7771 47.6095 68.0633 48.3455C68.3844 48.5244 68.69 48.7469 68.9657 48.9829L68.9773 48.9916C69.809 49.7198 70.4203 50.6918 70.7916 51.7324Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_384_1003",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 47,
    width: 11,
    height: 7
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000183932316410724906580000005215203451237313929__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M70.7916 51.7324C69.9367 52.2789 68.9637 52.7044 67.9328 52.9917C66.4927 53.4008 64.9385 53.5439 63.4462 53.4317C62.4346 53.3553 61.4394 53.1638 60.5342 52.8475C60.8553 51.982 61.215 51.0922 61.6793 50.303C62.2015 49.3929 62.8737 48.6105 63.8002 48.1386C65.1261 47.4645 66.7771 47.6095 68.0633 48.3455C68.3844 48.5244 68.69 48.7469 68.9657 48.9829L68.9773 48.9916C69.809 49.7198 70.4203 50.6918 70.7916 51.7324Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_384_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M63.0304 47.9376C61.5584 48.7558 60.7073 50.5605 61.012 52.2162C61.3166 53.872 62.7538 55.2559 64.4201 55.4977C66.0865 55.7395 67.8573 54.8207 68.6194 53.3188C70.3922 49.8264 66.455 46.0333 63.0304 47.9376Z",
    fill: "#4E505B"
  })))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    opacity: 0.8,
    d: "M62.6091 20.4528C68.5493 26.6087 77.7458 29.424 86.1135 27.6483C88.2808 27.1889 90.4878 26.3775 91.9443 24.7082C93.4018 23.0389 93.8409 20.3271 92.4298 18.6182",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    opacity: 0.8,
    d: "M55.6312 21.2383C46.1436 26.7307 41.3263 39.3121 41.4597 48.4042",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    opacity: 0.8,
    d: "M65.9253 18.4254C69.1816 20.7968 72.9864 22.6392 77.0125 22.7514C81.0387 22.8636 85.2796 20.9535 87.1385 17.3799",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    opacity: 0.8,
    d: "M67.1992 14.2622C71.3724 15.327 76.0563 14.1007 79.1724 11.1287C80.2594 10.0919 81.1763 8.82983 81.5699 7.38106C81.9635 5.93132 81.774 4.28042 80.8513 3.09568C79.9296 1.91287 78.419 1.33549 76.9373 1.10822C74.8967 0.794864 72.6171 1.12561 71.1529 2.58115C69.6886 4.03669 69.5 6.79789 71.1451 8.04549",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    opacity: 0.8,
    d: "M53.4736 17.3232C46.0701 18.9964 39.8785 25.1725 38.186 32.5721",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    opacity: 0.8,
    d: "M78.5251 30.3597C82.2854 31.4815 86.3706 31.4902 90.1366 30.3848C93.1221 29.5086 96.041 27.7977 97.4733 25.0356C98.9046 22.2734 98.3321 18.3613 95.6647 16.7598",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    opacity: 0.8,
    d: "M79.8445 24.9049C84.6869 24.9359 89.365 21.5935 90.9066 17.0034C92.4472 12.4134 90.7325 6.9249 86.8524 4.02832",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    opacity: 0.8,
    d: "M47.6194 23.96C40.4906 30.3141 36.7826 40.2988 38.035 49.7661",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M86.8827 109.02C86.7376 109.045 86.5925 109.076 86.4475 109.115C86.6419 109.064 86.9842 109.169 87.1835 109.197C87.4388 109.234 87.6931 109.277 87.9465 109.33C88.4049 109.424 88.8547 109.435 89.2367 109.745C89.5636 110.01 89.7483 110.5 89.5423 110.866C89.3402 111.227 88.874 111.326 88.4639 111.377C87.7134 111.472 86.9591 111.532 86.2028 111.556C86.9871 111.777 89.7483 112.532 88.6477 113.725C87.9813 114.449 85.6815 114.374 84.7772 114.406C85.1234 114.393 85.5567 114.749 85.8237 114.933C86.1757 115.176 86.5684 115.433 86.6892 115.87C86.7734 116.176 86.7134 116.532 86.4881 116.755C86.3246 116.917 86.0935 116.994 85.8652 117.013C85.1467 117.072 84.4629 116.813 83.7695 116.669C82.0673 116.316 80.369 115.949 78.6736 115.567C76.455 115.067 75.2954 114.5 73.0613 115.381C63.9799 118.963 49.4003 119.926 42.4795 111.545C36.285 104.044 34.7347 92.838 39.0549 84.0593C40.2048 81.7236 43.7464 78.9518 46.174 79.8938C48.322 80.7275 49.8094 82.6878 51.0125 84.6531C53.9265 89.4133 55.8627 94.7693 56.6674 100.293C61.9567 100.11 67.8368 102.745 72.8679 104.388C74.1058 104.793 75.1832 105.12 76.3399 104.492C77.7055 103.751 79.0759 103.02 80.4619 102.318C80.7646 102.165 81.075 102.01 81.4116 101.972C81.7481 101.933 82.1215 102.033 82.3236 102.304C82.5625 102.626 82.4948 103.093 82.2946 103.441C82.0944 103.789 81.7849 104.058 81.5257 104.364C81.3729 104.544 81.2327 104.751 81.2162 104.986C81.1891 105.374 81.5218 105.712 81.8923 105.828C82.812 106.112 83.9049 106.049 84.8575 106.211C86.0035 106.405 87.138 106.673 88.2502 107.013C88.6148 107.125 89.0491 107.337 89.2396 107.691C89.3382 107.875 89.3547 108.107 89.2589 108.293C89.1313 108.539 88.8479 108.655 88.581 108.733C88.2744 108.822 87.9601 108.884 87.6428 108.919C87.3846 108.947 87.1332 108.976 86.8827 109.02Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M53.0155 76.0358C59.356 84.124 57.5562 93.2412 57.5562 93.2412C57.5562 93.2412 49.8172 97.1001 35.9155 88.8881C35.9155 88.8881 40.0375 67.3635 53.0155 76.0358Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    opacity: 0.5,
    d: "M53.0155 76.0358C59.356 84.124 57.5562 93.2412 57.5562 93.2412C57.5562 93.2412 49.8172 97.1001 35.9155 88.8881C35.9155 88.8881 40.0375 67.3635 53.0155 76.0358Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M35.3701 88.6377C41.6642 93.1861 49.9932 94.7954 57.5292 92.9202",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    opacity: 0.5,
    d: "M46.2998 111.349C48.6171 111.297 50.9169 112.579 52.091 114.577",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    opacity: 0.5,
    d: "M55.9711 100.464C55.1161 100.597 54.2602 100.731 53.4053 100.864",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M81.0439 155.481C78.276 152.251 75.8098 148.624 73.5883 145.009C67.7284 147.391 60.5958 148.378 54.4138 146.762C49.0665 145.366 42.0693 141.689 41.5248 135.555C41.1525 131.364 43.4049 127.21 46.7241 124.622C51.4786 120.916 58.0338 120.048 63.8782 119.919C69.034 119.804 77.2866 119.344 81.6881 122.243C84.7916 124.286 88.2975 128.976 89.666 132.43C91.7763 137.755 93.198 141.338 94.0297 147.386C94.3556 149.756 95.8953 151.822 95.7174 154.206C95.5587 156.319 94.4514 157.943 92.7299 159.09C91.2095 160.103 89.6476 161.532 87.6746 161.082C85.9734 160.694 84.6378 159.412 83.4405 158.143C82.6214 157.274 81.8225 156.386 81.0439 155.481Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M94.7106 143.541C95.0733 145.046 95.2029 147.102 95.9002 148.476C96.6517 149.959 97.4012 149.578 99.0898 149.884C101.94 150.403 104.675 151.561 107.019 153.266C108.685 154.477 110.258 156.192 110.259 158.251C110.26 159.654 109.501 160.978 108.463 161.92C107.426 162.863 106.129 163.472 104.818 163.971C96.4718 167.152 85.1369 167.359 79.9685 158.956C78.4231 156.444 77.4956 153.715 76.6416 151.018C81.6939 147.947 88.9465 145.471 94.7106 143.541Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M76.7913 151.081C82.6328 148.209 88.7044 145.805 94.9289 143.9",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M41.4909 137.287C40.2945 132.411 42.9619 127.165 47.0229 124.211C51.0829 121.258 56.262 120.258 61.2814 120.123",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    opacity: 0.5,
    d: "M68.8018 136.616C69.9468 138.874 71.0929 141.131 72.238 143.389",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    opacity: 0.5,
    d: "M77.832 122.808C78.2963 124.742 80.245 126.206 82.2315 126.114",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby14Weeks);
export default __webpack_public_path__ + "static/media/baby-14-weeks.8a44fbe177fa12f6d7eb158a4be6e52b.svg";
export { ForwardRef as ReactComponent };